"use strict";

Shopify.theme.jsAccounts = {
  init: function init($section) {
    $('.js-recover-password').on('click', function () {
      $('#login').hide();
      $('#recover-password').show();
    });
    $('.cancel-recover-password').on('click', function () {
      $('#recover-password').hide();
      $('#login').show();
    });
    if(window.location.search == "?bom=true") {
      $("#bom-return").append('<input type="hidden" name="return_to" value="/cart">')
   }
  },
  unload: function unload($section) {
    $('.js-recover-password').off();
    $('.cancel-recover-password').off();
  }
};